import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  PinInput,
  PinInputField,
  useBreakpointValue,
} from '@chakra-ui/react';
import { Base } from '../Base';
import styles from './OTP.styles';

const inputArray = ({ length, defaultValue = '' }) => Array.from({ length }, (_, index) => ({
  id: index,
  defaultValue,
  key: `pin-${index}`,
  subDataTestId: `pinInput${index}`,
}));

export const OTPField = forwardRef((props, ref) => {
  const {
    name,
    size: sizeProp,
    value,
    error,
    onBlur,
    onChange,
    isDisabled,
    valueLength,
    'data-testid': dataTestId,
    ...contentProps
  } = props;
  const size = useBreakpointValue({ base: 'sm', sm: 'md' });
  const inputs = useMemo(() => inputArray({ length: valueLength }), []);

  return (
    <Base
      name={name}
      size={sizeProp || size}
      data-testid={dataTestId}
      error={error}
      isDisabled={isDisabled}
      {...contentProps}
    >
      <Flex gridColumnGap={{ base: '1', sm: '2' }}>
        <PinInput
          otp
          size={sizeProp || size}
          value={value}
          type="number"
          placeholder=""
          onChange={onChange}
          isInvalid={!!error}
          isDisabled={isDisabled}
        >
          {inputs.map(({
            id,
            key,
            defaultValue,
            subDataTestId,
          }) => (
            <PinInputField
              key={key}
              onBlur={onBlur}
              value={defaultValue}
              ref={id === 0 ? ref : undefined}
              data-testid={`${dataTestId}.${subDataTestId}`}
              {...styles.pinInputField}
            />
          ))}
        </PinInput>
      </Flex>
    </Base>
  );
});

OTPField.defaultProps = {
  value: '',
  error: null,
  valueLength: 6,
  onBlur: () => {},
  isDisabled: false,
  'data-testid': 'otp',
  onChange: () => {},
};

OTPField.propTypes = {
  onBlur: PropTypes.func,
  error: PropTypes.shape({ message: PropTypes.string }),
  value: PropTypes.string,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  valueLength: PropTypes.number,
  'data-testid': PropTypes.string,
  name: PropTypes.string.isRequired,
};
